import { FILTER_CONFIG, SALARY_FILTER_MAP } from '../v2/components/filters/FilterConfig';
import { isNormalizedMatch } from './textUtils';

export const validateMscCompatibility = ({
  excelMscDescription,
  salaryType,
  row,                // The full row object from Excel processing
  allRules,           // MSC Header V2 list from options
  employeeTypes,      // Full EmployeeType list to check flags
  maintenanceTypes,   // Enums list
  mscFilters          // FEATURES.MAINTENANCE_SALARY_FILTERS
}) => {
  if (salaryType !== "MaintenanceSalaryCombination") return { isValid: true };

  if (!excelMscDescription || excelMscDescription.trim() === "") {
    return { isValid: false, error: "MSC Description is required for this Salary Type." };
  }

  // 1. Resolve Employee Type behavior
  // First, find the ID field name for Employee Type from the map
  const empTypeIdField = SALARY_FILTER_MAP["EMPLOYEE_TYPE"]; // "employeeTypeId"
  const rowEmpTypeId = row[empTypeIdField];
  
  const empTypeObj = employeeTypes.find(t => t.id?.toString() === rowEmpTypeId?.toString());
  const disregardOthers = empTypeObj?.maintenanceSalaryCombinationDisregardOtherFilter === true;

  // 2. Identify which "Base Keys" are required
  // If disregard is true, we only care about EMPLOYEE_TYPE
  // If false, we process all keys in FEATURES.MAINTENANCE_SALARY_FILTERS
  const activeBaseKeys = disregardOthers 
    ? ["EMPLOYEE_TYPE"]
    : mscFilters.map(key => FILTER_CONFIG[key]?.dropdownTypeKey ?? key);

  // 3. Find Rules that match the logical combination of IDs in the row
  const matchingRules = allRules.filter(rule => {
    // A rule is a match ONLY if it satisfies EVERY active base key
    return activeBaseKeys.every(baseKey => {
      // A. Map Base Key to Row Property (e.g. "DEPARTMENT" -> "departmentId")
      const rowProperty = SALARY_FILTER_MAP[baseKey];
      const targetValueId = row[rowProperty];

      // B. Map Base Key to Maintenance Type ID (e.g. "DEPARTMENT" -> Type 5)
      const typeId = maintenanceTypes.find(t => t.name === baseKey)?.value;

      // C. Check the Rule's details for this specific Type + Value combo
      const detail = rule.details?.find(d => d.maintenanceTypeId === typeId);
      
      return detail && detail.maintenanceValueId?.toString() === targetValueId?.toString();
    });
  });

  // 4. Final step: Does the provided description match one of these valid rules?
  const finalMatch = matchingRules.find(r => isNormalizedMatch(r.description, excelMscDescription));

  if (!finalMatch) {
    return { 
      isValid: false, 
      error: `'${excelMscDescription}' is not valid for the selected ${disregardOthers ? 'Employee Type' : 'combination of criteria'}.` 
    };
  }

  return { isValid: true, ruleId: finalMatch.id };
};